import React, { PropsWithChildren } from 'react';

import { ThemeProvider as Provider } from 'styled-components';

import palette from './palette';
import fonts from './fontFamilies';
import breakPoint, { mediaQueries } from './breakPoint';
import { Theme } from './types';
import zIndices from './zIndices';

const uiKitTheme: Theme = {
  palette,
  fonts,
  breakPoint,
  mediaQueries,
  zIndices,
};

export const ThemeProvider = ({
  children,
  theme,
}: PropsWithChildren<{ theme?: Theme }>) => {
  const extendedTheme = { ...uiKitTheme, ...(theme ?? {}) };
  return <Provider theme={extendedTheme}>{children}</Provider>;
};

export default uiKitTheme;
